<h3 class="mt-5" class="mt-5">
  {{ data.details.title.split(' ')[0] }} <span> {{ data.details.title.split(' ')[1] }}</span>
</h3>

<div class="row text-center my-5 align-items-center">
  <div class="col p-0" *ngFor="let item of data.details.services">
    <img [src]="item.imageUrl" />
    <p class="name">{{ item.name }}</p>
    <h4 class="number" dir="ltr">{{ item.number }}</h4>
  </div>
</div>
